import { Image, useMantineColorScheme } from "@mantine/core"
import _ from "lodash"

import { useBrand } from "@costory/front/lib/whitelabel"

export function IconMetrics({ value }: { value: string }) {
  const { colorScheme } = useMantineColorScheme()
  const brand = useBrand()

  if (
    _.includes(
      ["cost", "list_cost", "effective_cost", "contracted_cost"],
      value,
    )
  ) {
    return <Image src="/img/finops.png" w={20} h={20} />
  }
  if (
    _.includes(
      [
        "unblended_cost",
        "net_unblended_cost",
        "amortized_cost",
        "net_amortized_cost",
      ],
      value,
    )
  ) {
    const src =
      colorScheme === "light" ? "/img/aws-logo.png" : "/img/aws-logo-dark.png"
    return <Image src={src} w={20} h={20} />
  }

  const src = colorScheme === "light" ? brand.logoDark : brand.logoLight
  return <Image src={src} w={20} h={20} />
}
